import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { PaymentService } from '../../shared/payment/services/payment.service';
import { TeamDetails } from '@tokenbox/domain';
import { environment } from '../../../environments/environment.development';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { PrimeIcons } from 'primeng/api';

enum UpgradeTo {
  PRO,
  ENTERPRISE,
}

@Component({
  selector: 'dt-upgrade-link',
  templateUrl: './upgrade-link.component.html',
  styleUrls: ['./upgrade-link.component.scss'],
  imports: [ButtonDirective, ButtonIcon, ButtonLabel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeLinkComponent {
  team = input.required<TeamDetails>();

  protected readonly PrimeIcons = PrimeIcons;
  private paymentService = inject(PaymentService);

  protected readonly UpgradeTo = UpgradeTo;

  salesEmailAddress = environment.contact.email;

  permittedToUpgrade = computed(
    () => !!this.team().ownPermissions?.MANAGE_TEAM,
  );

  upgradeTo = computed(() =>
    this.team().plan.paidPlan ? UpgradeTo.ENTERPRISE : UpgradeTo.PRO,
  );

  upgradeUrl = computed(() =>
    this.paymentService.buildCheckoutUrlForCurrentUser(this.team().id),
  );
}
